import React from 'react';
import authRoles from '../../../auth/authRoles';
import StaffListing from './StaffListing';
import EditStaff from './EditStaff';
import AddStaff from './AddStaff';
import StaffInformation from './StaffInformation';

const StaffConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/staff',
			// component: StaffListing
			element: (
				<React.Suspense fallback={<>...</>}>
					<StaffListing />
				</React.Suspense>
			),
		},
		{
			path: '/staff-editstaff/:id',
			// component: EditStaff
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditStaff />
				</React.Suspense>
			),
		},
		{
			path: '/staff-addstaff',
			// component: AddStaff
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddStaff />
				</React.Suspense>
			),
		},
		{
			path: '/staff-info/:id',
			// component: StaffInformation
			element: (
				<React.Suspense fallback={<>...</>}>
					<StaffInformation />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default StaffConfig;
